/* eslint-disable */
import Header from "components/Common/Header/Header";
import ProductInfoBody from "components/MarketplaceComponents/ProductComponents/ProductDetails/VitalInfo/ProductInfoBody/ProductInfoBody";
import { useEffect } from "react";

const ProductInfo = () => {
  useEffect(() => {
    document.title = "Marketplace";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="marketplace" />
      <ProductInfoBody />
    </main>
  );
};

export default ProductInfo;
